import React from 'react';

const EmptyState = ({ 
  user,
  onOpenAddModal,
  onOpenTemplateModal
}) => {
  return (
    <div className="text-center py-5">
      <i className="bi bi-inbox display-4 text-muted"></i>
      <h5 className="mt-3 text-muted">
        {user?.role === 'admin' 
          ? 'No hay plantillas públicas del sistema' 
          : 'No tienes tipos de documentos personalizados'
        }
      </h5>
      <p className="text-muted">
        {user?.role === 'admin'
          ? 'Crea plantillas que podrán ser utilizadas por todos los usuarios del sistema'
          : 'Crea un nuevo tipo de documento o importa una plantilla predefinida'
        }
      </p>
      <div className="d-flex gap-2 justify-content-center mt-3">
        <button 
          className="btn btn-primary"
          onClick={onOpenAddModal}
        >
          <i className="bi bi-plus me-2"></i>
          {user?.role === 'admin' ? 'Crear Plantilla' : 'Crear Nuevo'}
        </button>
        {user?.role !== 'admin' && (
          <button 
            className="btn btn-outline-primary"
            onClick={onOpenTemplateModal}
          >
            <i className="bi bi-download me-2"></i>
            Importar Plantilla
          </button>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
